/** React */
import React, { HTMLAttributes, useContext, useMemo } from "react";

/** Hook */
import { useMenu } from "./menu-root";

/** Props */
type Props = HTMLAttributes<HTMLDivElement> & {
  "data-menu-id"?: string | undefined;
};

export function MenuContent({ children, ...props }: Props) {
  const { items } = useContext(useMenu());
  const menuId = useMemo(() => props["data-menu-id"], [props]);
  const isExpanded = useMemo(() => {
    return items[menuId as string]?.isExpanded;
  }, [items, menuId]);

  if (!isExpanded) return;

  return <div {...props}>{children}</div>;
}
